import SEOHead from '../components/SEOHead';
import GoogleReviews from '../components/GoogleReviews';

export default function ReviewsPage() {
  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="reviews-page">
      <SEOHead
        title="Reviews | Flash Funding"
        description="Read verified Google reviews from Flash Funding clients across Australia."
        canonical="/reviews"
      />

      <GoogleReviews variant="full" />
    </div>
  );
}
